<div class="con" style="margin-left: 10%;margin-right: 10%;">
  <div class="title">
    <h1>{{"Incident Types" | translate | async}}</h1>
  </div>
  
  <div class="details" >
    <div *ngIf="this.incidentList.length > 0">
      <mat-list role="list" *ngFor="let cat of this.incidentList;index as catIndex" >
        <mat-list-item role="listitem">

          <button mat-button (click)="ChangeActive(cat)" mat-icon->
            <mat-icon *ngIf="cat.Active" style="color:green">done</mat-icon>
            <mat-icon *ngIf="!cat.Active" style="color:red">close</mat-icon>
          </button>

              <span style="padding-right: 24cm; flex: auto;" >{{cat.Name}} </span>
              <mat-checkbox *ngIf="cat.TRIFR || !cat.TRIFR" [checked]="cat.TRIFR" (click)="ChangeTRIFR(cat)" style="margin-left: 10px;">TRIFR
              </mat-checkbox>
              <button style ="margin-top: 0px;" mat-button (click)="OpenEditIncidentTypeDialog(cat)" mat-icon->
                <mat-icon>create</mat-icon>
              </button>
        </mat-list-item>
      </mat-list>
      </div>
  </div>
  
    
      <div class="row">
        <div class="marg">
        <div class="column">    
            <button (click) = "OpenAddIncidentTypeDialog()" style="margin: top 2px;" mat-raised-button color="lightgray">
              <mat-icon>add</mat-icon>{{'Add Incident Type' | translate | async}}
            </button>    
        </div>
        </div>
        </div>
      </div>